/* DistrictPrime visual effects (looks only). No libraries. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window)) return; // leave everything visible
  root.classList.add('dp-fx-ready');

  var CARD_SEL = 'main product-card.product-card, main .collection-card';
  var HEAD_SEL = 'main h1, main h2, main h3';
  /* cards in carousels, sliders or horizontal scrollers are never hidden: rise-in is for grid cards only */
  var SLIDER_SEL = 'slideshow-component, slideshow-container, slideshow-slides, slideshow-slide, carousel-component, ' +
    '.resource-list__carousel, .slideshow, [class*="carousel"], [class*="slider"]';

  function inSlider(el) {
    if (el.closest(SLIDER_SEL)) return true;
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var ox = getComputedStyle(p).overflowX;
      if (ox === 'auto' || ox === 'scroll') return true;
    }
    return false;
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0 && r.left < window.innerWidth && r.right > 0;
  }

  /* 2. cards rise in, once each, with a short stagger per batch */
  var batch = 0, batchTimer = null;
  var cardIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.style.setProperty('--dp-fx-delay', Math.min(batch, 6) * 70 + 'ms');
      batch++;
      el.classList.add('dp-fx-in');
      cardIO.unobserve(el);
    });
    clearTimeout(batchTimer);
    batchTimer = setTimeout(function () { batch = 0; }, 120);
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  /* 4. neon headings, once each */
  var headIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('dp-fx-lit');
      headIO.unobserve(e.target);
    });
  }, { threshold: 0.5 });

  function scan(scope) {
    var cards = (scope.matches && scope.matches(CARD_SEL)) ? [scope] : [];
    cards = cards.concat(Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll(CARD_SEL) : []));
    cards.forEach(function (el) {
      if (el.classList.contains('dp-fx-card') || el.closest('dialog, .header, .header-drawer')) return;
      if (inSlider(el)) return;
      el.classList.add('dp-fx-card');
      if (reduce) { el.classList.add('dp-fx-in'); return; }
      cardIO.observe(el);
    });
    var heads = scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(HEAD_SEL)) : [];
    if (scope.matches && scope.matches(HEAD_SEL)) heads.push(scope);
    heads.forEach(function (h) {
      if (h.classList.contains('dp-fx-neon') || h.classList.contains('visually-hidden') || h.closest('dialog, .visually-hidden')) return;
      h.classList.add('dp-fx-neon');
      if (reduce) { h.classList.add('dp-fx-lit'); return; }
      headIO.observe(h);
    });
  }
  scan(document);

  /* watch for cards added later (carousels, infinite load, filtering) */
  var main = document.getElementById('MainContent') || document.body;
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
    });
  }).observe(main, { childList: true, subtree: true });

  /* 1. background zoom fallback for browsers without scroll-driven animations */
  if (!reduce && !(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'))) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, window.scrollY / max));
      root.style.setProperty('--dp-bg-scale', (1 + 0.08 * p).toFixed(4));
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }
})();
